import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=c238c8fc&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
import style0 from "./Customer.vue?vue&type=style&index=0&id=c238c8fc&prod&scoped=true&lang=css"
import style1 from "./Customer.vue?vue&type=style&index=1&id=c238c8fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c238c8fc",
  null
  
)

export default component.exports